import { useState, type FormEvent } from 'react'
import type { Result } from '../api/client'
import type { User } from '../api/types'
import { Centered } from '../components/Centered'

export function SignInScreen({
  serverName,
  notice,
  allowRegistration,
  onSignIn,
  onRegister,
  onChangeServer,
}: {
  serverName: string
  /** Why you are looking at this screen, when you did not ask to be. */
  notice?: string
  /** What the server said about sign-ups. A club that has closed them is offered nothing. */
  allowRegistration: boolean
  onSignIn: (email: string, password: string) => Promise<Result<User>>
  onRegister: () => void
  onChangeServer: () => void
}) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)

    const result = await onSignIn(email.trim(), password)
    if (!result.ok) {
      setBusy(false)
      setError(result.error.message)
    }
    // On success the shell moves on and this screen is unmounted, so there is nothing to reset.
  }

  return (
    <Centered>
      <form className="card stack" onSubmit={submit} style={{ width: 380 }}>
        <div>
          <h1>Sign in</h1>
          {serverName && (
            <p className="muted" style={{ margin: '4px 0 0' }}>
              {serverName}
            </p>
          )}
        </div>

        {notice && !error && <div className="banner info">{notice}</div>}

        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="username"
            autoFocus
          />
        </div>

        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
          />
        </div>

        {error && <div className="banner danger">{error}</div>}

        <button type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        {allowRegistration && (
          <button type="button" className="ghost" onClick={onRegister}>
            Create an account
          </button>
        )}

        <button type="button" className="ghost" onClick={onChangeServer}>
          Use a different server
        </button>
      </form>
    </Centered>
  )
}
